@import "../../../globalStyles/commons";


:host {
  display: inline-block;
  /**
    * @prop --goat-menu-background: Background color of the menu
   */
  --goat-menu-background: var(--layer);

  /**
    * @prop --goat-menu-max-height: Maximum height of the menu
   */
  --goat-menu-max-height: 100%;

  /**
    * @prop --goat-menu-shadow: Shadow of the menu
   */
  --goat-menu-shadow: 0 2px 6px 0 rgba(0,0,0,.2);

  min-width: 10rem;
}

.menu {
  background: var(--goat-menu-background);
  box-sizing: border-box;
  max-height: var(--goat-menu-max-height);
  overflow-x: auto;
  border: 1px solid #{v(--border-subtle)};
  box-shadow: var(--goat-menu-shadow);
  padding-block: v(--spacing-02);
}

:host(.no-border) .menu {
  border: none;
  box-shadow: none;
}
